/**
 * Shared chess types. Domain-only — no UI or engine imports.
 * Adapter implementations map library types into these shapes.
 */

export type File = 'a' | 'b' | 'c' | 'd' | 'e' | 'f' | 'g' | 'h';
export type Rank = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8';
export type Square = `${File}${Rank}`;

export type Color = 'w' | 'b';
export type Role = 'k' | 'q' | 'r' | 'b' | 'n' | 'p';

export interface Piece {
  role: Role;
  color: Color;
}

export interface Move {
  from: Square;
  to: Square;
  promotion?: Role;
  san?: string;
  /** UCI e.g. e2e4, e7e8q */
  uci?: string;
}

export interface BoardSnapshot {
  fen: string;
  turn: Color;
  pieces: ReadonlyMap<Square, Piece>;
}

/** Starting position FEN. */
export const START_FEN =
  'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1';

export function isStartFen(fen: string): boolean {
  return fen.replace(/\s+/g, ' ').trim() === START_FEN;
}
